"use client";

import { useAppDispatch, useAppSelector } from './hooks';
import { showModal, ModalType } from './slices/modalSlice';
import { useEffect, useRef } from 'react';

export const useModal = () => {
    const dispatch = useAppDispatch();
    const { isOpen, resolveValue } = useAppSelector((state) => state.modal);
    const resolveRef = useRef<(value: boolean) => void>(null);

    useEffect(() => {
        if (!isOpen && resolveRef.current !== null) {
            resolveRef.current(resolveValue || false);
            resolveRef.current = null;
        }
    }, [isOpen, resolveValue]);

    const alert = (message: string, options?: { title?: string; type?: ModalType }) => {
        dispatch(showModal({
            message,
            title: options?.title,
            type: options?.type || 'info',
            isConfirming: false
        }));
    };

    const confirm = (message: string, options?: { title?: string; confirmLabel?: string; cancelLabel?: string }): Promise<boolean> => {
        return new Promise((resolve) => {
            resolveRef.current = resolve;
            dispatch(showModal({
                message,
                title: options?.title || '确定删除该项目吗?',
                type: 'confirm',
                confirmLabel: options?.confirmLabel,
                cancelLabel: options?.cancelLabel,
                isConfirming: true
            }));
        });
    };

    const error = (message: string, title?: string) => alert(message, { title, type: 'error' });
    const success = (message: string, title?: string) => alert(message, { title, type: 'success' });
    const warning = (message: string, title?: string) => alert(message, { title, type: 'warning' });

    return { alert, confirm, error, success, warning };
};
